
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as PuzzleIcon } from "../fontello/icons/svg/ic_puzzle.svg"


const Puzzle = ({ ...props }) => (
  <SvgIcon
    component={PuzzleIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Puzzle
